import { render, staticRenderFns } from "./FixedTop.vue?vue&type=template&id=64cfb7b5&scoped=true&"
import script from "./FixedTop.vue?vue&type=script&lang=js&"
export * from "./FixedTop.vue?vue&type=script&lang=js&"
import style0 from "./FixedTop.vue?vue&type=style&index=0&id=64cfb7b5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cfb7b5",
  null
  
)

export default component.exports